<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { IDropdownItem } from "../../../../services/DTO";
  import { StatusRuleService } from "../../../../services/status-rule.service";
  import SearchDropdown from "./SearchDropdown.svelte";

  export let placeholder: string = "";
  export let required: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = true;
  export let name: string = "";
  export let schema: string = "";
  export let value: number = null;

  const dispatch = createEventDispatcher();

  let items: IDropdownItem[] = [];

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }

  async function search(filter: string) {
    let selfId = !!value ? value : 0;
    let values = await StatusRuleService.searchValueCombo(
      schema,
      selfId,
      filter
    ).toPromise();
    items = values.payload || [];
  }

  function onSelect(event: CustomEvent) {
    if (event == null) {
      dispatch("clear");
    } else {
      dispatch("select", event.detail);
    }
  }

  onMount(() => search(""));
</script>

<SearchDropdown
  {placeholder}
  {required}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  bind:value
  on:filter={onFilter}
  on:select={onSelect}
/>
